import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import EventButton from '../../../atoms/EventButton/EventButton';

var Indicator = function Indicator(_ref) {
  var index = _ref.index,
      currentIndex = _ref.currentIndex,
      changeCurrentIndex = _ref.changeCurrentIndex,
      event = _ref.event;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "Carousel image number " + index,
    event: _extends({}, event, {
      value: index
    }),
    className: "ic-carousel-indicator",
    style: {
      padding: 0,
      background: 'none'
    },
    onClick: function onClick() {
      return changeCurrentIndex(index);
    },
    size: "large",
    icon: index === currentIndex ? 'circle' : 'circle outline'
  });
};

Indicator.defaultProps = {
  event: {
    category: 'Carousel',
    action: 'Click',
    label: 'Image Collection'
  }
};
export default Indicator;